var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.RZ=require("crc-32");module.exports=$CLJS.RZ;